import React, { useEffect } from 'react';

import clsx from 'clsx';
import GlobalFilter from './GlobalFilter';
import { lighten, makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { MdDelete, MdOpenInNew } from 'react-icons/md';
import { MdLink } from 'react-icons/md';

import DeleteIcon from '@material-ui/icons/Delete';
import "./styles.scss";

const useToolbarStyles = makeStyles((theme) => ({
	root: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
		borderRadius: 8,
		color: '#1f2a5a'
	},
	highlight:
		theme.palette.type === 'light'
			? {
				color: '#1f2a5a',
				backgroundColor: '#5b7edd91'
			}
			: {
				color: '#1f2a5a',
				backgroundColor: '#5b7edd91'
			},
	title: {
		flex: '1 1 100%'
	}
}));

const TableToolbar = (props) => {
	const classes = useToolbarStyles();
	const {
		numSelected,
		addHandler,
		genericHandler,
		deleteHandler,
		preGlobalFilteredRows,
		setGlobalFilter,
		globalFilter,
		title,
		dialog,
		singleActions,
		multiActions
	} = props;

	const defaultSAction = React.useMemo(() => [

	]);
	const defaultMAction = React.useMemo(() => [

	]);
	const [tableSingleActions, setTableSingleActions] = React.useState(defaultSAction);
	const [tableMultiActions, setTableMultiActions] = React.useState(defaultMAction);

	useEffect(
		() => {
			if (typeof multiActions == 'object') {
				setTableMultiActions([...multiActions, ...defaultMAction]);
			}
		},
		[multiActions]
	);
	useEffect(
		() => {
			if (typeof singleActions == 'object') {
				setTableSingleActions([...singleActions, ...defaultSAction]);
			}
		},
		[singleActions]
	);

	const renderNavActions = (mode) => {
		if (mode > 1) {
			if (typeof tableMultiActions == 'object') {
				return tableMultiActions.map((action, index) => {
					return (
						<Tooltip key={index} title={action.title}>
							<IconButton aria-label={action.label} onClick={() => genericHandler(action.actionCallback)}>
								{action.icon}
							</IconButton>
						</Tooltip>
					);
				});
			}
		} else {
			if (typeof tableSingleActions == 'object') {
				return tableSingleActions.map((action, index) => {
					return (
						<Tooltip key={index} title={action.title}>
							<IconButton aria-label={action.label} onClick={() => genericHandler(action.actionCallback)}>
								{action.icon}
							</IconButton>
						</Tooltip>
					);
				});
			}
		}
		return null
	};

	return (
		<Toolbar
			className={clsx(classes.root, {
				[classes.highlight]: numSelected > 0
			})}
		>
			{dialog}
			{numSelected > 0 ? (
				<Typography className={classes.title} color="inherit" variant="subtitle1">
					{numSelected} selected
				</Typography>
			) : (
					<Typography className={classes.title} variant="h6" id="tableTitle">
						{title}
					</Typography>
				)}
			{/* {dialog} */}

			{numSelected > 0 ? (
				renderNavActions(numSelected)
			) : (
					<GlobalFilter
						preGlobalFilteredRows={preGlobalFilteredRows}
						globalFilter={globalFilter}
						setGlobalFilter={setGlobalFilter}
					/>
				)}
		</Toolbar>
	);
};

TableToolbar.propTypes = {
	numSelected: PropTypes.number.isRequired,
	addHandler: PropTypes.func.isRequired,
	genericHandler: PropTypes.func.isRequired,
	setGlobalFilter: PropTypes.func.isRequired,
	preGlobalFilteredRows: PropTypes.array.isRequired,
	globalFilter: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	dialog: PropTypes.element.isRequired,
	actions: PropTypes.func.isRequired,
};

export default TableToolbar;
